import React from 'react';

import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import DeleteExternalJobBoardForm from './DeleteExternalJobBoardForm';

import { useExternalJobBoardsState, useExternalJobBoardsActions } from './ExternalJobBoardsContext';

const DeleteExternalJobBoardModal = () => {
  const externalJobBoardsState = useExternalJobBoardsState();
  const { closeDeleteExternalJobBoardModal } = useExternalJobBoardsActions();

  return (
    <StandardModal
      isOpen={externalJobBoardsState?.deleteExternalJobBoardModalIsOpen}
      contentLabel={'Delete External Job Board'}
      onRequestClose={() => {
        closeDeleteExternalJobBoardModal();
      }}
    >
      <PageTitle text={'Delete External Job Board'} />
      <DeleteExternalJobBoardForm />
    </StandardModal>
  );
};

export default DeleteExternalJobBoardModal;